import React from "react";
import { ChevronDown } from "lucide-react";
import { yearOptions } from "../../reports/finance/financePeriodUtils";

export const PERIOD_TYPES = [
  { value: "year", label: "Năm" },
  { value: "quarter", label: "Quý" },
  { value: "month", label: "Tháng" },
];

const selectClsBase =
  "appearance-none h-11 w-full bg-white text-gray-700 pl-3 pr-9 rounded-xl text-sm font-semibold outline-none transition-all cursor-pointer focus:border-red-500 focus:ring-4 focus:ring-red-500/5";

const selectCls = `${selectClsBase} border border-gray-200`;
const selectClsStrong = `${selectClsBase} border-2 border-gray-200`;

/** Class đồng bộ ô tìm kiếm với select kỳ */
export const FINANCE_FILTER_SEARCH_CLS =
  "w-full h-11 bg-white border border-gray-200 pl-11 pr-4 rounded-xl text-sm font-medium text-gray-700 outline-none transition-all focus:border-red-500 focus:ring-4 focus:ring-red-500/5";

/**
 * Bộ lọc kỳ: Loại thời gian (Năm/Quý/Tháng) + khoảng tương ứng.
 * onPeriodChange(patch) — parent nên applyPeriodChange(filters, patch).
 */
export default function FinancePeriodFilterControls({
  periodType = "month",
  year,
  quarter = 1,
  month = 1,
  onPeriodChange,
  compact = false,
  strongBorder = false,
  className = "",
}) {
  const type = periodType || "month";
  const fieldCls = strongBorder ? selectClsStrong : selectCls;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <div className={`relative ${compact ? "min-w-[7.5rem]" : "min-w-[8.5rem]"}`}>
        <select
          value={type}
          onChange={(e) => onPeriodChange?.({ period_type: e.target.value })}
          aria-label="Loại thời gian"
          className={`${fieldCls} w-full`}
        >
          {PERIOD_TYPES.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
        <ChevronDown
          size={16}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
        />
      </div>

      {type === "year" ? (
        <div className={`relative ${compact ? "min-w-[7.5rem]" : "min-w-[8.5rem]"}`}>
          <select
            value={year || ""}
            onChange={(e) => onPeriodChange?.({ year: Number(e.target.value) })}
            aria-label="Chọn năm"
            className={`${fieldCls} w-full`}
          >
            {yearOptions().map((y) => (
              <option key={y} value={y}>
                Năm {y}
              </option>
            ))}
          </select>
          <ChevronDown
            size={16}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
          />
        </div>
      ) : null}

      {type === "quarter" ? (
        <>
          <div className={`relative ${compact ? "min-w-[6.5rem]" : "min-w-[7.5rem]"}`}>
            <select
              value={quarter || 1}
              onChange={(e) =>
                onPeriodChange?.({ quarter: Number(e.target.value) })
              }
              aria-label="Chọn quý"
              className={`${fieldCls} w-full`}
            >
              {[1, 2, 3, 4].map((q) => (
                <option key={q} value={q}>
                  Quý {q}
                </option>
              ))}
            </select>
            <ChevronDown
              size={16}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
          </div>
          <div className={`relative ${compact ? "min-w-[6.5rem]" : "min-w-[7.5rem]"}`}>
            <select
              value={year || ""}
              onChange={(e) => onPeriodChange?.({ year: Number(e.target.value) })}
              aria-label="Chọn năm"
              className={`${fieldCls} w-full`}
            >
              {yearOptions().map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
            <ChevronDown
              size={16}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
          </div>
        </>
      ) : null}

      {type === "month" ? (
        <>
          <div className={`relative ${compact ? "min-w-[7rem]" : "min-w-[8rem]"}`}>
            <select
              value={month || 1}
              onChange={(e) =>
                onPeriodChange?.({ month: Number(e.target.value) })
              }
              aria-label="Chọn tháng"
              className={`${fieldCls} w-full`}
            >
              {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                <option key={m} value={m}>
                  Tháng {m}
                </option>
              ))}
            </select>
            <ChevronDown
              size={16}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
          </div>
          <div className={`relative ${compact ? "min-w-[6.5rem]" : "min-w-[7.5rem]"}`}>
            <select
              value={year || ""}
              onChange={(e) => onPeriodChange?.({ year: Number(e.target.value) })}
              aria-label="Chọn năm"
              className={`${fieldCls} w-full`}
            >
              {yearOptions().map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
            <ChevronDown
              size={16}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
          </div>
        </>
      ) : null}
    </div>
  );
}
